"use client";

import { useEffect, useMemo, useState } from "react";
import { TickerItem } from "@/components/landing/ticker-item";
import type { StartupRecord } from "@/lib/types";

type ApiResponse = {
  data: StartupRecord[];
};

export function LandingMarketTicker() {
  const [startups, setStartups] = useState<StartupRecord[]>([]);

  useEffect(() => {
    async function load() {
      try {
        const response = await fetch("/api/market-ticker", { cache: "no-store" });
        if (!response.ok) return;

        const payload = (await response.json()) as ApiResponse;
        setStartups(payload.data ?? []);
      } catch {
        // Keep the strip hidden if the ticker cannot load.
      }
    }

    load();
  }, []);

  const items = useMemo(() => {
    if (!startups.length) return [];
    return [...startups, ...startups];
  }, [startups]);

  if (!items.length) return null;

  return (
    <section className="landing-market-ticker" aria-label="Live startup market ticker">
      <div className="ticker-shell">
        <div className="ticker-track">
          {items.map((startup, index) => (
            <TickerItem key={`${startup.slug}-${index}`} startup={startup} />
          ))}
        </div>
      </div>
    </section>
  );
}
